import { TextKey } from '@mews-commander/enums';
import { ReservationState } from '@mews-commander/data-access';

export const TEXT_LENGTH = 35;

export const customerTypesOptions = {
    customer: TextKey.Customer,
    company: TextKey.Company,
    ota: TextKey.TravelAgency,
};

export const reservationStatusOptions = {
    [ReservationState.Future]: TextKey.ReservationTimeStateFuture,
    [ReservationState.ToBeCheckedIn]: TextKey.ReservationTimeStateToBeCheckedIn,
    [ReservationState.CheckInMissed]: TextKey.ReservationTimeStateCheckInMissed,
    [ReservationState.CheckedIn]: TextKey.CheckedIn,
    [ReservationState.ToBeCheckedOut]: TextKey.ReservationTimeStateToBeCheckedOut,
    [ReservationState.CheckOutMissed]: TextKey.ReservationTimeStateCheckOutMissed,
    [ReservationState.Past]: TextKey.ReservationTimeStatePast,
    [ReservationState.CheckedInOnline]: TextKey.OnlineCheckedIn,
    [ReservationState.CheckedOutOnline]: TextKey.OnlineCheckedOut,
    [ReservationState.Cancelled]: TextKey.ServiceOrderStateCanceled,
    [ReservationState.Optional]: TextKey.ServiceOrderStateOptional,
    [ReservationState.Inquired]: TextKey.ServiceOrderStateInquired,
};
